import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  DropDownsModule,
  AutoCompleteModule
} from '@progress/kendo-angular-dropdowns';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { MenuModule } from '@progress/kendo-angular-menu';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { GridModule, PDFModule, ExcelModule } from '@progress/kendo-angular-grid';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { GridDropdownFilterComponent } from './components/filters/grid-dropdown-filter/grid-dropdown-filter.component';
import { GridDaterangeFilterComponent } from './components/filters/grid-daterange-filter/grid-daterange-filter.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { UploadModule  } from '@progress/kendo-angular-upload';
import { EditorModule } from '@progress/kendo-angular-editor';
import { RippleModule } from '@progress/kendo-angular-ripple';
import { IntlModule } from '@progress/kendo-angular-intl';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { SwitchModule } from '@progress/kendo-angular-inputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { FloatingLabelModule } from '@progress/kendo-angular-label';
import { UploadInterceptor } from './interceptor/upload-interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UploadComponent } from './components/upload/upload.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GridDaterangePwaFilterComponent } from './components/filters/grid-daterange-pwa-filter/grid-daterange-pwa-filter.component';


@NgModule({
  declarations: [GridDropdownFilterComponent, GridDaterangeFilterComponent, UploadComponent, GridDaterangePwaFilterComponent],
  imports: [
    CommonModule,
    DropDownsModule,
    AutoCompleteModule,
    GridModule,
    PopupModule,
    DialogModule,
    InputsModule,
    MenuModule,
    PopupModule,
    ButtonsModule,
    PDFModule,
    ExcelModule,
    ChartsModule,
    MenuModule,
    ButtonsModule,
    DateInputsModule,
    LayoutModule,
    SwitchModule,
    DialogsModule,
    TreeViewModule,
    NotificationModule,
    FloatingLabelModule,
    BrowserAnimationsModule,
    UploadModule,
    FormsModule,
  ],

  exports: [
    DropDownsModule,
    AutoCompleteModule,
    GridModule,
    PopupModule,
    DialogModule,
    InputsModule,
    MenuModule,
    PopupModule,
    ButtonsModule,
    PDFModule,
    ExcelModule,
    ChartsModule,
    MenuModule,
    ButtonsModule,
    GridDropdownFilterComponent,
    GridDaterangeFilterComponent,
    DateInputsModule,
    UploadModule,
    EditorModule,
    RippleModule,
    IntlModule,
    LayoutModule,
    SwitchModule,
    DialogsModule,
    TreeViewModule,
    NotificationModule,
    FloatingLabelModule,
    UploadComponent,
    GridDaterangePwaFilterComponent
  ],
  providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UploadInterceptor,
            multi: true
        }
    ]
})
export class KendoModule { }
